import React, {
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
// import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import Pagination from "../../Common/Pagination/Pagination";
import { sweetAlert } from "../../Common/Utills/Utills";
import AddVehicleUtilities from "./AddVehicleUtilities";
import UpdateVehicleUtilities from "./UpdateVehicleUtilities";

const VehicleUtilities = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [rmvBtn, setRmvBtn] = useState(false);
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectedRowsData, setSelectedRowsData] = useState({});
  const [rowAddData, setRowAddData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const formRef = useRef(null);
  // console.log("rowData", rowAddData)
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);
  const [company, setCompany] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [vehicle, setVehicle] = useState([]);
  const [selectVehicleId, setSelectVehicleId] = useState("");
  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    gridRef.current.api.showLoadingOverlay();
  };

  // Add a function to handle page size change
  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  const [filterCriteria, setfilterCriteria] = useState({
    company_id: "",
    vehicle_id: "",
    assembling_date: "",
  });

  const handleFilterChange = (name, value) => {
    setfilterCriteria((prevFilterCriteria) => {
      return {
        ...prevFilterCriteria,
        [name]: value,
      };
    });
  };

  function resetFileds() {
    setRowAddData("");
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const updateHandleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setSelectedRowsData(() => {
        return {
          ...selectedRowsData,
          [name]: value,
        };
      });
    } else {
      console.error("Event or event.target is undefined");
    }
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { vehicle_number } = rowAddData;

    let BASE_URL =
      SERVER_URL + `/api/vehicle-details/vehicle-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        vehicle_number,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        resetFileds();
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getData = async () => {
    const nonEmptyFilterCriteria = Object.fromEntries(
      Object.entries(filterCriteria).filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
    );
    const options = {
      whereFilters: nonEmptyFilterCriteria,
      skip: currentPage,
      take: pageSize,
    };
    let BASE_URL =
      SERVER_URL +
      `/api/vehicle-utilities/all-vehicle-utilities-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    });
    const result = await res.json();
    if (res.ok) {
      setRowData(result.data);
      setTotalRecords(result.total);
      // Check if gridRef is defined and has the api property before using it
      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.hideOverlay();
      }
    } else {
      setRowData([]);
    }
  };

  let check = true;
  const [loadingOverlayVisible, setLoadingOverlayVisible] = useState(false);
  useEffect(() => {
    if (check) {
      if (loadingOverlayVisible) {
        if (gridRef.current && gridRef.current.api) {
          gridRef.current.api.showLoadingOverlay();
        }
      }
      getData();
      setLoadingOverlayVisible(true);
    }
    check = false;
  }, []);

  useEffect(() => {
    getData();
  }, [currentPage, pageSize, filterCriteria]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filterCriteria]);

  // const addData = (newData) => {
  //   console.log("Adding data:", newData);
  //   setRowData((prevData) => [...prevData, newData]);
  // };

  const onCellValueChanged = (params) => {
    const updatedData = params.data;
    updateData(updatedData);
    // setRowData((prevData) =>
    //   prevData.map((row) => (row === params.data ? updatedData : row))
    // );
    // console.log("Updated data:", updatedData);
  };

  const onSelectionChanged = useCallback((event) => {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes?.length > 1) {
      setRmvBtn(true);
    }
    if (selectedNodes?.length < 2) {
      setRmvBtn(false);
    }
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRows(selectedData);
    // window.alert("selection changed, " + rowCount + " rows selected");
  }, []);

  const deleteRow = async (id) => {
    const message = "Do you want to delete this vehice utilities details!";
    const result = await sweetAlert(message);
    if (!result.isConfirmed) {
      return;
    }
    let BASE_URL =
      SERVER_URL +
      `/api/vehicle-utilities/vehicle-utilities-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const addDataToModal = async (rowData) => {
    setSelectedRowsData(rowData);
  };
  const updateData = async (rowData) => {
    const {
      id,
      vehicle_id,
      utility_type,
      utility_name,
      service_count,
      utility_usage,
      service_need,
      vehicle_part_breakdown,
      expense_of_breakdown,
      assembling_date,
    } = rowData;
    let BASE_URL = SERVER_URL + `/api/vehicle-utilities/vehicle-utilities-details/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        vehicle_id,
        vehicle_id,
        utility_type,
        utility_name,
        service_count,
        utility_usage,
        service_need,
        vehicle_part_breakdown,
        expense_of_breakdown,
        assembling_date,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
      // getData();
    } else {
      toast.error(response.message);
      // getData();
    }
  };
  const [colDefs, setColDefs] = useState([
    {
      headerName: "S. No",
      valueGetter: (params) => {
        const currentPageContext = params.context.currentPage;
        const pageSizeContext = params.context.pageSize;
        return (
          (currentPageContext - 1) * pageSizeContext + params.node.rowIndex + 1
        );
      },
      minWidth: 100,
      // headerCheckboxSelection: true,
      // checkboxSelection: true,
    },
    // {
    //   headerName: "Company Name",
    //   field: "companyDetails.company_name",
    //   valueFormatter: (params) => {
    //     const location = params.data.companyDetails.location;
    //     // const type = params.data.company.type;
    //     return `${params.value} - ${location}`;
    //   },
    //   editable: false,
    //   minWidth: 250,
    // },
    {
      headerName: "Vehicle Number",
      field: "vehicleDetails.vehicle_number",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Utility Name",
      field: "utility_name",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Utility Type",
      field: "utility_type",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Assembling Date",
      field: "assembling_date",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Service Count",
      field: "service_count",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Utility Usage",
      field: "utility_usage",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Service Need",
      field: "service_need",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Vehicle Part Breakdown",
      field: "vehicle_part_breakdown",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Expense Of Breakdown",
      field: "expense_of_breakdown",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => deleteRow(params.data.id)}
          >
            <i className="mdi mdi-delete" />
          </button>{" "}
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => addDataToModal(params.data)}
            data-toggle="modal"
            data-target="#editModal"
          >
            <i className="mdi mdi-note-edit-outline" />
          </button>
        </>
      ),
      minWidth: 205,
    },
  ]);

  const sortingOrder = useMemo(() => {
    return ["desc", "asc", null];
  }, []);
  const defaultColDef = useMemo(() => ({
    filter: true,
    flex: 1,
    editable: true,
    headerPosition: "sticky",
  }));
  const gridOptions = useMemo(
    () => ({
      rowSelection: "multiple",
      suppressRowClickSelection: true,
      suppressCellSelection: true,
    }),
    []
  );
  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  const handleRefreshClick = () => {
    gridRef.current.api.showLoadingOverlay();
    setfilterCriteria({
      company_id: "",
      vehicle_id: "",
      assembling_date: "",
    });
    setSelectVehicleId("");
    setSelectedCompanyId("");
    getData();
  };

  const onGridReady = useCallback((params) => {
    params.api.showLoadingOverlay();
  });

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  const handleCompanyFilterChange = (e) => {
    const companyId = e.target.value ? parseInt(e.target.value) : "";
    setSelectedCompanyId(companyId);
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: companyId,
    }));
  };

  const getVehicle = async () => {
    let BASE_URL =
      SERVER_URL + `/api/vehicle-details/all-vehicle-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setVehicle(result.data);
  };

  useEffect(() => {
    getVehicle();
  }, []);

  const handleFilterVehicleChange = (e) => {
    const vehicleId = e.target.value ? parseInt(e.target.value) : "";
    setSelectVehicleId(vehicleId);
    setfilterCriteria((preventDefault) => ({
      ...preventDefault,
      vehicle_id: vehicleId,
    }));
  };
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            Vehicle Utilities Table &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div>
          <div className="table_btn">
            <div className="mb-3">
              <button
                data-toggle="modal"
                data-target="#exampleModal"
                className="btn btn-outline-primary"
              >
                <span className="mr-1">
                  <i className="mdi mdi-briefcase-upload" />
                </span>
                Add Vehicle Utilities
              </button>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <button
                onClick={() => onBtnExport()}
                className="btn btn-outline-excel mr-1 "
              >
                <span className="mr-1">
                  <i className="mdi mdi-file-export"></i>
                </span>
                Export to Excel
              </button>
            </div>
          </div>
          <div
            className="search mb-3"
            style={{
              transition: "background-color 0.3s",
              paddingTop: "10px 20px",
            }}
          >
            <div className="row">
              {/* <div className="col-md-3">
                <div className="form-group">
                  <select
                    className="form-control form-control-lg"
                    onChange={handleCompanyFilterChange}
                    value={selectedCompanyId}
                  >
                    <option value="">Select Company (All)</option>
                    {company &&
                      company?.length > 0 &&
                      company?.map((item, id) => {
                        return (
                          <React.Fragment key={id}>
                            <option
                              value={item.id}
                              key={id}
                            >{`${item.company_name}, ${item.location}`}</option>
                          </React.Fragment>
                        );
                      })}
                  </select>
                </div>
              </div> */}
              <div className="col-md-3">
                <div className="form-group">
                  <select
                    className="form-control form-control-lg"
                    onChange={handleFilterVehicleChange}
                    value={selectVehicleId}
                    id="material_name"
                    required
                  >
                    <option value="">Select Vehicle</option>
                    {vehicle &&
                      vehicle?.length > 0 &&
                      vehicle?.map((item, id) => {
                        return (
                          <option
                            value={item.id}
                            key={id}
                          >{`${item.vehicle_number}`}</option>
                        );
                      })}
                  </select>
                </div>
              </div>
              <div className="col-md-3" style={{ display: "flex" }}>
                <input
                  type="date"
                  className="form-control"
                  value={filterCriteria.assembling_date}
                  onChange={(e) =>
                    handleFilterChange("assembling_date", e.target.value)
                  }
                />
              </div>
            </div>
          </div>
          <div>
            <div
              className="ag-theme-quartz"
              style={{ width: "100%", height: 550 }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                // domLayout="autoHeight"
                headerHeight={40}
                rowHeight={50}
                context={{ currentPage, pageSize }}
                sortingOrder={sortingOrder}
                enableCellTextSelection={true}
                // gridOptions={gridOptions}
                rowSelection={"multiple"} // For row selection
                suppressRowClickSelection={true} // For row selection
                suppressCellSelection={true} // For row selection
                onGridReady={onGridReady}
                overlayLoadingTemplate={
                  '<span className="ag-overlay-loading-center">Please wait while your records are loading...</span>'
                }
                onCellValueChanged={onCellValueChanged}
                onSelectionChanged={onSelectionChanged}
              />
            </div>
          </div>

          <AddVehicleUtilities
            handleChange={handleChange}
            getData={getData}
            handleAddDataSubmit={handleAddDataSubmit}
            formRef={formRef}
            setRowAddData={setRowAddData}
            rowAddData={rowAddData}
            setSelectedRowsData={setSelectedRowsData}
          />
          <UpdateVehicleUtilities
            selectedRowsData={selectedRowsData}
            updateHandleChange={updateHandleChange}
            getData={getData}
            setRowAddData={setRowAddData}
            rowAddData={rowAddData}
            setSelectedRowsData={setSelectedRowsData}
          />
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default VehicleUtilities;
